import { getOrdinalSuffixForSuperScript } from 'src/consumer/helpers/utilFunctions'

const VisitCornerBadge = ({ bookedSlot, apptCalendarSettings, styles }) => {
  const shouldShow = 
    bookedSlot?.patientMeetingSeqNumber === 1 ||
    (bookedSlot?.patientMeetingSeqNumber !== 1 && apptCalendarSettings?.patientVisits)

  if (!shouldShow) return null

  const isNewPatient = bookedSlot?.patientMeetingSeqNumber === 1
  const showVisitNumber = apptCalendarSettings?.patientVisits && !isNewPatient

  return (
    <div style={styles.visitCornerStyle}>
      {isNewPatient ? (
        <span style={{ color: styles.leftStripTextColor || '#FFFFFF', fontWeight: 600 }}>
          New
        </span>
      ) : (
        showVisitNumber && (
          <span style={{ color: styles.leftStripTextColor || '#FFFFFF', fontWeight: 600 }}>
            {bookedSlot?.patientMeetingSeqNumber}
            <sup>
              {getOrdinalSuffixForSuperScript(bookedSlot?.patientMeetingSeqNumber)}
            </sup>{' '}
            Visit
          </span>
        )
      )}
    </div>
  )
}

export default VisitCornerBadge